import React, { useState, useEffect, useCallback } from 'react';
import { Alert } from 'react-bootstrap';
import API from '../services/api';
import './UpdateNotification.css';

const UpdateNotification = () => {
  const [showUpdateNotification, setShowUpdateNotification] = useState(false);
  const [countdown, setCountdown] = useState(5);
  const [currentVersion, setCurrentVersion] = useState('');

  // 获取当前版本信息
  const fetchCurrentVersion = useCallback(async () => {
    try {
      const response = await API.get('/api/update/version');
      const serverVersion = response.data.version;
      
      const localVersion = localStorage.getItem('systemVersion');
      
      if (!localVersion) {
        localStorage.setItem('systemVersion', serverVersion);
        setCurrentVersion(serverVersion);
      } else if (localVersion !== serverVersion) {
        console.log('检测到系统更新:', { localVersion, serverVersion });
        setCurrentVersion(serverVersion);
        setShowUpdateNotification(true);
        setCountdown(5);
      }
    } catch (error) {
      console.error('获取版本信息失败:', error);
    }
  }, []);

  // 定期检查版本更新
  useEffect(() => {
    fetchCurrentVersion();
    const interval = setInterval(fetchCurrentVersion, 60000);
    
    return () => {
      clearInterval(interval);
    };
  }, [fetchCurrentVersion]);

  // 手动刷新页面
  const handleRefresh = useCallback(() => {
    localStorage.setItem('systemVersion', currentVersion);
    window.location.reload();
  }, [currentVersion]);

  // 倒计时逻辑
  useEffect(() => {
    if (showUpdateNotification && countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else if (showUpdateNotification && countdown === 0) {
      handleRefresh();
    }
  }, [showUpdateNotification, countdown, handleRefresh]);

  // 取消更新
  const handleCancel = () => {
    setShowUpdateNotification(false);
    localStorage.setItem('systemVersion', currentVersion);
  };

  if (!showUpdateNotification) {
    return null;
  }

  return (
    <div className="update-notification-container">
      <Alert 
        variant="warning" 
        className="update-notification-alert"
        dismissible={false}
      >
        <div className="update-notification-content">
          <div className="update-notification-icon">
            🔄
          </div>
          <div className="update-notification-text">
            <strong>系统更新提醒</strong>
            <div className="update-notification-message">
              检测到系统存在新版本更新，页面将在 
              <span className="countdown-text">{countdown}</span> 
              秒后自动刷新以应用更新
            </div>
          </div>
          <div className="update-notification-actions">
            <button 
              className="btn btn-sm btn-primary me-2"
              onClick={handleRefresh}
            >
              立即更新
            </button>
            <button 
              className="btn btn-sm btn-outline-secondary"
              onClick={handleCancel}
            >
              稍后提醒
            </button>
          </div>
        </div>
      </Alert>
    </div>
  );
};

export default UpdateNotification; 